export default __webpack_public_path__ + "static/media/opel.2b2f44b6.png";